import {Box, Button, css, IconButton, Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	width: 100%;
	padding: ${({theme}) => theme.spacing(2)};
	box-shadow: 0px 4px 22px 0px #33333314;
	background-color: ${({theme}) => theme.colors.gray['10Percent']};

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-inline: ${({theme}) => theme.spacing(4)};
	}
`;

const StyledUfsWrapper = styled(Box)`
	position: relative;
	padding-right: 40px;
	max-width: 1140px;
`;

const StyledUfsList = styled(Box)<{$isExpanded: boolean}>`
	overflow: hidden;
	max-height: ${({$isExpanded}) => ($isExpanded ? '400px' : '36px')};
	transition: max-height 0.2s ease-in-out;
`;

const StyledExpandButton = styled(IconButton)`
	position: absolute;
	top: 0;
	right: 0;
	border: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
`;

const StyledButton = styled(Button)<{$isSelected: boolean}>`
	padding: 4px 12px 4px 12px;
	min-width: 32px;
	line-height: 24px;
	${({theme, $isSelected}) => css`
		background-color: ${$isSelected ? theme.palette.other.inversedColorIconBg : undefined};
		color: ${$isSelected ? theme.palette.primary.main : theme.palette.text.secondary};
		border-color: ${$isSelected
			? theme.palette.primary.main
			: theme.palette.other.outlineBorder};

		&:hover {
			background-color: theme.palette.action.hover;
			border-color: ${$isSelected ? theme.palette.primary.dark : theme.palette.divider};
		}
	`}
`;

export {StyledContainer, StyledUfsWrapper, StyledUfsList, StyledExpandButton, StyledButton};
